/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiRole } from './ApiRole';
import {
    ApiRoleFromJSON,
    ApiRoleFromJSONTyped,
    ApiRoleToJSON,
    ApiRoleToJSONTyped,
} from './ApiRole';

/**
 * 
 * @export
 * @interface RolesPage
 */
export interface RolesPage {
    /**
     * 
     * @type {number}
     * @memberof RolesPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof RolesPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof RolesPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiRole>}
     * @memberof RolesPage
     */
    content: Array<ApiRole>;
}

/**
 * Check if a given object implements the RolesPage interface.
 */
export function instanceOfRolesPage(value: object): value is RolesPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function RolesPageFromJSON(json: any): RolesPage {
    return RolesPageFromJSONTyped(json, false);
}

export function RolesPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RolesPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiRoleFromJSON)),
    };
}

export function RolesPageToJSON(json: any): RolesPage {
    return RolesPageToJSONTyped(json, false);
}

export function RolesPageToJSONTyped(value?: RolesPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiRoleToJSON)),
    };
}

